import { dirname, join } from 'node:path';
import { fileURLToPath } from 'node:url';

/** Absolute path to the built `bridge-mcp-server.js` next to the CLI bundle. */
export function resolveBridgeMcpServerScriptPath(): string {
  const cliDir = dirname(fileURLToPath(import.meta.url));
  return join(cliDir, 'bridge-mcp-server.js');
}
